import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="shop main">
      <div className="shop-container">
        <h1 className="shop-title">Shop</h1>
        <div className="products-grid">
          {productData.map((product) => (
            <Link
              to={`/shopDetails/${product.id}`}
              onClick={toTop}
              key={product.id}
              className="product-card"
            >
              <div className="product-image-container">
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
                {product.onSale && <span className="sale-badge">Sale</span>}
              </div>
              <div className="product-info">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-brand">{product.brand || "tunrisefield"}</p>
                <div className="product-rating">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={`star ${i < Math.round(product.rating) ? "filled" : ""}`}
                    >
                      ★
                    </span>
                  ))}
                  <span className="review-count">({product.reviews})</span>
                </div>
                <p className="product-price">${product.price}</p>
                
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Shop;
